<div
  #host
  class="three-host"
  [class.is-empty]="!imageUrl"
  [class.is-editing]="showPerspectiveEditor"
  [class.is-compare]="mode === 'compare'"
  [class.is-loading]="isProcessing"
  (wheel)="onWheel($event)"
  (pointerdown)="onCompareHostPointerDown($event)"
  (pointermove)="onCompareDividerPointerMove($event)"
  (pointerup)="onCompareDividerPointerUp($event)"
  (pointercancel)="onCompareDividerPointerUp($event)"
>
  <canvas
    #canvas
    class="three-canvas"
    (pointerdown)="onCanvasPointerDown($event)"
    (pointermove)="onCanvasPointerMove($event)"
    (pointerup)="onCanvasPointerUp($event)"
    (pointercancel)="onCanvasPointerUp($event)"
  ></canvas>
  <div class="canvas-loader-overlay" *ngIf="isProcessing">
    <span class="loader"></span>
    <div class="canvas-loader-text">
      {{ loadingText || 'Menyiapkan mask dan slice surface...' }}
    </div>
  </div>

  <div
    class="compare-divider"
    *ngIf="mode === 'compare' && (resultImageUrl || previewTextureUrl)"
    [style.left.px]="compareDividerLeft"
    (pointerdown)="onCompareDividerPointerDown($event)"
  >
    <span class="compare-handle"></span>
  </div>

  <svg
    class="surface-polygon-layer"
    *ngIf="false"
    [attr.viewBox]="'0 0 ' + host.clientWidth + ' ' + host.clientHeight"
    preserveAspectRatio="none"
  >
    <polygon
      *ngFor="let hotspot of screenHotspots"
      class="surface-polygon"
      [class.active]="isHotspotActive(hotspot)"
      [class.configured]="hotspot.isConfigured"
      [attr.points]="hotspot.polygonPoints"
    ></polygon>
    <g *ngFor="let hotspot of screenHotspots" class="surface-corner-group" [class.active]="isHotspotActive(hotspot)">
      <g *ngFor="let point of hotspot.polygonPointList">
        <circle
          class="surface-corner-dot"
          r="6"
          [attr.cx]="point.x"
          [attr.cy]="point.y"
        ></circle>
        <text
          class="surface-corner-label"
          [attr.x]="point.x + 9"
          [attr.y]="point.y - 8"
        >{{ hotspot.label }} {{ point.label }}</text>
      </g>
    </g>
  </svg>

  <div
    class="surface-hotspot-layer"
    *ngIf="imageUrl && imageWidth > 0 && mode !== 'compare'"
  >
    <button
      type="button"
      class="surface-hotspot"
      *ngFor="let hotspot of screenHotspots"
      [class.active]="isHotspotActive(hotspot)"
      [class.configured]="hotspot.isConfigured"
      [style.left.px]="hotspot.x"
      [style.top.px]="hotspot.y"
      [attr.aria-label]="hotspot.label"
      [title]="hotspot.hint"
      (pointerdown)="onHotspotPointerDown($event)"
      (pointerup)="onHotspotPointerUp($event, hotspot)"
      (click)="onHotspotClick($event, hotspot)"
    >
      <span class="hotspot-dot"></span>
      <span class="hotspot-label">{{ hotspot.label }}</span>
      <span class="hotspot-product" *ngIf="hotspot.productSku">{{ hotspot.productSku }}</span>
    </button>
  </div>

  <svg
    *ngIf="showPerspectiveEditor && imageUrl && imageWidth > 0"
    class="quad-overlay"
    [attr.viewBox]="'0 0 ' + host.clientWidth + ' ' + host.clientHeight"
    preserveAspectRatio="none"
    (pointermove)="onOverlayPointerMove($event)"
    (pointerup)="onOverlayPointerUp($event)"
    (pointercancel)="onOverlayPointerUp($event)"
  >
    <polygon class="quad-polygon" [attr.points]="overlayPolygonPoints()"></polygon>
    <line
      *ngFor="let segment of overlaySegments()"
      class="quad-guide"
      [attr.x1]="segment.x1"
      [attr.y1]="segment.y1"
      [attr.x2]="segment.x2"
      [attr.y2]="segment.y2"
    ></line>
    <g *ngFor="let point of overlayPointList()">
      <circle
        class="quad-handle"
        r="10"
        [attr.cx]="point.x"
        [attr.cy]="point.y"
        (pointerdown)="onHandlePointerDown($event, point.key)"
      ></circle>
      <text class="quad-label" [attr.x]="point.x + 14" [attr.y]="point.y - 14">{{ point.label }}</text>
    </g>
  </svg>

  <div class="canvas-empty" *ngIf="!imageUrl">
    <mat-icon class="empty-icon" aria-hidden="true">image</mat-icon>
    <strong>Belum ada ruangan</strong>
    <span>Unggah foto PNG/JPG atau pilih contoh ruangan.</span>
  </div>

  <div class="canvas-status" *ngIf="statusMessage && imageUrl">
    {{ statusMessage }}
  </div>

  <div class="canvas-tools" *ngIf="imageUrl && mode !== 'compare'">
    <button type="button" (click)="zoomOut()" aria-label="Perkecil">
      <mat-icon aria-hidden="true">remove</mat-icon>
    </button>
    <label class="zoom-value-control" aria-label="Nilai zoom">
      <input
        type="number"
        min="35"
        max="400"
        step="1"
        [value]="zoomPercent"
        (change)="updateZoomPercent($any($event.target).value)"
        (keydown.enter)="$any($event.target).blur()"
      />
      <span>%</span>
    </label>
    <button type="button" (click)="zoomIn()" aria-label="Perbesar">
      <mat-icon aria-hidden="true">add</mat-icon>
    </button>
    <button type="button" (click)="resetView()" aria-label="Reset tampilan">
      <mat-icon aria-hidden="true">center_focus_strong</mat-icon>
    </button>
    <button type="button" *ngIf="showPerspectiveEditor" (click)="useDefaultQuad()">Quad default</button>
  </div>

</div>
